export const invoices = {
    namespaced: true,
    state: {
        listStatus: 'initial',
        list: [],
        lastStatus: 'initial',
        pagination: {
            total: 0,
            current: 1
        },
        last: {
            invoice_no: '',
            gross_price: 0,
            is_paid: false
        },
        summary: {
            sum_gross: 0
        },
        pdfStatus: 'initial'
    },
    mutations: {
        SET_LIST_STATUS(state, listStatus) {
            state.listStatus = listStatus
        },
        SET_LIST(state, list) {
            state.list = list
        },
        SET_LAST_STATUS(state, lastStatus) {
            state.lastStatus = lastStatus
        },
        SET_LAST(state, last) {
            state.last = last
        },
        SET_PAGINATION_TOTAL(state, total) {
            state.pagination.total = total
        },
        SET_PAGINATION_CURRENT(state, current) {
            state.pagination.current = current
        },
        SET_SUMMARY(state, summary) {
            state.summary = summary
        },
        SET_PDF_STATUS(state, pdfStatus) {
            state.pdfStatus = pdfStatus
        }
    },
    actions: {
        fetchList({ commit, getters, dispatch }, payload) {
            commit('SET_LIST_STATUS', 'pending')
            const params = {
                date_mode: payload.dateMode,
                date_from: payload.startDate,
                date_to: payload.endDate,
                term: payload.term ? payload.term : '',
                page: getters.paginationCurrent
            }
            const esc = encodeURIComponent
            const query = Object.keys(params)
                .filter(k => params[k] !== '')
                .map(k => `${esc(k)}=${esc(params[k])}`)
                .join('&')
            return this.$api.get(`client/v2/invoices/list?${query}`).then(response => {
                if(response.status === 200) {
                    commit('SET_LIST', response.data.data.items)
                    commit('SET_PAGINATION_TOTAL', response.data.data.metadata.pageCount)
                    commit('SET_SUMMARY', response.data.data.summary)
                    commit('SET_LIST_STATUS', 'idle')
                }
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'invoices' }, { root: true })
                commit('SET_LIST_STATUS', 'idle')
            })
        },
        fetchLast({ commit, getters, dispatch }, payload) {
            commit('SET_LAST_STATUS', 'pending')
            return this.$api.get('client/v2/invoices/last').then(response => {
                if(response.status === 200) {
                    commit('SET_LAST', response.data.data)
                    commit('SET_LAST_STATUS', 'idle')
                }
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'invoices' }, { root: true }).then(() => {
                    commit('SET_LAST_STATUS', 'empty')
                })
            })
        },
        fetchPdf({ commit, getters, dispatch }, payload) {
            commit('SET_PDF_STATUS', `pending${payload.name}`)
            return this.$api.get(`client/v2/${payload.link}`, {
                responseType: 'arraybuffer'
            }).then(response => {
                if(response.status === 200) {
                    const file = new Blob([response.data], { type: 'application/pdf' })
                    const fileURL = URL.createObjectURL(file)
                    const link = document.createElement('a')
                    link.href = fileURL
                    link.download = `${payload.name}.pdf`
                    link.click()
                    commit('SET_PDF_STATUS', 'idle')
                }
            }).catch(error => {
                console.error(error)
            })
        },
        setListPage({ commit }, page) {
            commit('SET_PAGINATION_CURRENT', page)
        }
    },
    getters: {
        listStatus: state => state.listStatus,
        list: state => state.list,
        lastStatus: state => state.lastStatus,
        last: state => state.last,
        summary: state => state.summary,
        paginationTotal: state => state.pagination.total,
        paginationCurrent: state => state.pagination.current,
        pdfStatus: state => state.pdfStatus
    }
}
